import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@/i18n/config';
import { App } from './app';
import { applyBrandingToDocument } from './app-config/runtime/apply-branding';
import { loadAppProfile } from './app-config/runtime/load-app-profile';
import { createAppRouter } from './router';
import { hideAppLoader } from './shared/runtime/app-loader';
import './index.css';
import { getUserFacingErrorMessage } from './shared/errors/user-facing-error';

const rootElement = document.getElementById('root');

if (rootElement === null) {
  throw new Error('Root element #root was not found in index.html');
}

const root = createRoot(rootElement);

async function bootstrap(): Promise<void> {
  try {
    const profile = await loadAppProfile();
    applyBrandingToDocument(profile.branding);
    const router = createAppRouter(profile);
    root.render(
      <StrictMode>
        <App router={router} profile={profile} />
      </StrictMode>,
    );
  } catch (error) {
    console.error('Application bootstrap failed', error);
    const message = getUserFacingErrorMessage(
      error,
      '应用暂时无法启动，请刷新页面后重试。',
    );
    hideAppLoader();
    root.render(
      <main className="grid min-h-svh place-items-center p-6">
        <section className="max-w-xl rounded-xl border border-destructive/30 bg-card p-6 shadow-sm">
          <h1 className="text-lg font-semibold">
            应用暂时无法启动
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">{message}</p>
        </section>
      </main>,
    );
  }
}

void bootstrap();
